import { cpfDigit as verifierDigit } from "./modulo11"

const BLACKLIST = new Set([
  "00000000000",
  "11111111111",
  "22222222222",
  "33333333333",
  "44444444444",
  "55555555555",
  "66666666666",
  "77777777777",
  "88888888888",
  "99999999999",
  "12345678909",
])

const STRICT_STRIP_REGEX = /[.-]/g
const LOOSE_STRIP_REGEX = /[^\d]/g
const STRICT_MASK_REGEX = /^(?:\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/

/**
 * Remove caracteres de máscara e normaliza um CPF.
 *
 * @param value - Entrada a ser normalizada.
 * @param strict - Se `true`, remove apenas `.` e `-`. Se `false` ou omitido,
 *   remove qualquer caractere não numérico.
 * @returns Apenas os dígitos remanescentes.
 */
function strip(value, strict) {
  if (typeof value !== "string") return ""
  const regex = strict ? STRICT_STRIP_REGEX : LOOSE_STRIP_REGEX
  return value.replace(regex, "")
}

/**
 * Valida um CPF verificando tamanho, lista negra e os dois dígitos
 * verificadores via Módulo 11.
 *
 * @param value - CPF (cru, formatado ou com lixo, conforme `strict`).
 * @param strict - Se `true`, só aceita máscara canônica `XXX.XXX.XXX-XX`
 *   ou 11 dígitos puros. Se `false` ou omitido, remove qualquer lixo.
 * @returns `true` se o CPF é válido; `false` caso contrário.
 *
 * @example
 * ```ts
 * cpf.isValid('295.379.955-93') // true
 * cpf.isValid('29537995593')    // true
 * cpf.isValid('00000000000')    // false (blacklist)
 * ```
 */
export default function isValid(value, strict) {
  if (strict && (typeof value !== "string" || !STRICT_MASK_REGEX.test(value))) {
    return false
  }
  const stripped = strip(value, strict)
  if (!stripped || stripped.length !== 11 || BLACKLIST.has(stripped)) {
    return false
  }

  let numbers = stripped.slice(0, 9)
  numbers += verifierDigit(numbers)
  numbers += verifierDigit(numbers)
  return numbers.slice(-2) === stripped.slice(-2)
}
